<script setup lang="ts">
import { useModal } from '~/composables/use-modal'

const { modals, closeById } = useModal()
</script>

<template>
  <component
    :is="modal.component"
    v-for="modal in modals"
    :key="modal.id"
    v-bind="modal.props"
    :closeModal="() => closeById(modal.id)"
  />
</template>
